{
  "it": {
    "survey_type": {
      "actions": {
        "changeResponsible": "Cambia responsabile"
      },
      "attributes": {
        "introduction": "Introduzione",
        "responsible": "Responsabile",
        "title": "Titolo"
      },
      "labels": {
        "ask_question": "Che tipo di domanda desidera porre?",
        "editInternalTitle": "Modificare il titolo interno?",
        "explainerNPSPart1": "Il Net Promoter Score è un indice compreso tra -100 e 100 che misura la disponibilità dei clienti a raccomandare la Sua azienda o i Suoi progetti ad altri.",
        "explainerOpinionScale": "Misuri il grado di accordo dei Suoi clienti con un'affermazione generale.",
        "fixed_choice": "Domanda a scelta multipla",
        "hidePreview": "Nascondi anteprima",
        "moreInfo": "Maggiori informazioni",
        "nps": "Net Promoter Score",
        "npsQuestion": "NPS",
        "open_ended": "Domanda aperta",
        "opinion_scale": "Scala di opinione",
        "preview": "Anteprima",
        "satisfaction": "Soddisfazione",
        "selectSurveyType": "Seleziona questionario",
        "showPreview": "Mostra anteprima",
        "tab_summary": "Riepilogo",
        "tab_units": "Unità",
        "yes_no": "Sì-No"
      },
      "navigation": {
        "backToSurveyTypes": "Torna ai questionari"
      },
      "snackbars": {
        "duplicate": "Il questionario è stato creato, tuttavia il processo di copia del modello potrebbe richiedere alcuni minuti per essere completato."
      },
      "toasts": {
        "bulk_delete": "Questionario eliminato con successo | Questionari eliminati con successo",
        "update": "Questionario aggiornato con successo"
      },
      "validation": {
        "nameAlreadyTaken": "Il nome è già utilizzato per questo progetto",
        "need_name": "Titolo obbligatorio",
        "selectSurveyType": "Selezioni almeno 1 questionario"
      }
    }
  }
}
